import { Navigate } from "react-router-dom"
import { useAuth } from "../../context/AuthContext"

export default function ProtectedRoute({ children, requiredRole }) {
  const { user, userData, loading } = useAuth()

  if (loading) return null

  if (!user) return <Navigate to="/login" replace />

  if (requiredRole === "admin" && !userData?.es_admin)
    return <Navigate to="/" replace />

  if (requiredRole === "vendedor" && !userData?.es_vendedor && !userData?.es_admin)
    return <Navigate to="/" replace />

  return children
}